import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { Button } from "../atoms/button";
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/popup/popup.css';
import commonUtil from '../../common/commonUtil';
import '../../resources/css/soloReserve/golfSoloReservationPopup.css'
import common from '../../resources/js/common/common';
import { soloReservationDetail } from '../../const';

const GolfSoloReservationPopupContainer = (props) => {
    const {
        state,
        login,
        onClickClosePopupWindow,
        setGolfSoloReserveInfo,
    } = props;

    const [popupMessage, setPopupMessage] = useState('');
    let footerClass = "";
    const popupRef = useRef(null);
    moment.locale('ja')

    footerClass = "reservation";

    const history = useHistory();


    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    }, []);

    const onClose = () => {
        onClickClosePopupWindow();
        setPopupMessage('');
    }

    const afterSoloReservationDetail = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            setGolfSoloReserveInfo(data);
            onClose();
            history.push("/reserve/golf/soloBookingConfirmDetail");
        } else {
            // エラー処理
        }
    }

    // 予約確認
    const onClickConfirm = (req) => {
        common.doPost(soloReservationDetail, {userId: login.memberCode, reservationNo: req.reservationNo}, afterSoloReservationDetail)
    }

    return (
        <div ref={popupRef} className={state.golfReservationPopup ? "soloReservationPopup_isShow" : "soloReservationPopup_hidden"} id="js-popup">
            <div className="soloReservationPopup_popupInner">
                <div className="soloReservationPopup_popupHeader">
                    <ModalClose divStyle={"soloReservationPopup_close"} svgStyle={"soloReservationPopup_modalSvg"} onClick={() => onClose()} />
                    <h4 className="soloReservationPopup_innerText" >予約確認・キャンセル</h4>
                </div>
                <div className='soloReservationPopup_messageClass' />
                {popupMessage !== '' && popupMessage !== undefined ?
                    <div className='soloReservationPopup_messageText'> {popupMessage}</div>
                    :
                    null
                }
                {
                    (state.popupDataList === undefined || state.popupDataList.length == 0) ?
                        <div className='soloReservationPopup_noData'>
                            現在お預かりしているご予約はありません。
                        </div>
                        : null
                }
                {state.popupDataList ? state.popupDataList.map((value, index) =>
                    <div key={"bookConfirm" + index}
                        className={index === (state.popupDataList.length - 1) ? "soloReservationPopup_reserveList" : "soloReservationPopup_reserveListLast"}>
                        <div className="soloReservationPopup_table">
                            <div key={"checkIn" + index} className="soloReservationPopup_tableRow">
                                <div className='soloReservationPopup_tableColHeading'>お問合せ番号</div>
                                <div className='soloReservationPopup_inline'>{value.soloEntryReservationNo}</div>
                            </div>
                            <div key={"checkOut" + index} className="soloReservationPopup_tableRow">
                                <div className='soloReservationPopup_tableColHeading'>プレー日</div>
                                <div className='soloReservationPopup_inline'>{commonUtil.getStringFromDateJpnGolf(value.playDate)}</div>
                            </div>
                            <div key={"guestNum" + index} className="soloReservationPopup_tableRow">
                                <div className='soloReservationPopup_tableColHeading'>ゴルフ場</div>
                                <div className='soloReservationPopup_inline'>{value.golfCourseName}</div>
                            </div>
                            <div className="soloReservationPopup_buttonArea" >
                                <Button className="soloReservationPopup_confirmBtn" buttonClassName="soloReservationPopup_buttonText" onClick={() => onClickConfirm(value)} buttonText="予約内容を確認・キャンセル" />
                            </div>
                        </div>
                    </div>
                )
                    : null}
            </div>
            <div className="soloReservationPopup_blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        login: state.login,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setGolfSoloReserveInfo: (item) => {
            dispatch({ type: "GOLF_SOLO_RESERVE_INFO", payload: { golfSoloReserveInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfSoloReservationPopupContainer);